/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
// import { UncontrolledTooltip } from "reactstrap";
// ** Third Party Components
import classnames from "classnames";

// ** Cutome Component
import { Check, CheckCircle, HelpCircle, X } from "react-feather";
import PricingCalculatorModel from "../myprojects/createProjectSteps/PricingCalculatorModel";

import { useDispatch, useSelector } from "react-redux";
//subscriptionDetails
import { fetchPlans, subscriptionDetails } from "../../../redux/subscription";
import toast from "react-hot-toast";
import ToastContent from "../../components/toast/toast";

import PlansSkeleton from "../../../common/skeleton/PlanSkeleton/Plans";
import { createStripeCustomer } from "../../../services/subscription.service";
import PaymentWizard from "../../../common/PaymentModal/PaymentWizard";
import StripeElement from "../../../common/stripeComponent/StripeElement";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
import ConfirmModel from "../../components/modals/ConfirmModal";
import { getCurrentUser } from "../../../redux/currentUserSlice/currentUser.thunk";
import { useNavigate } from "react-router-dom";
import { USER_ROUTES } from "../../../constant/route";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { numberWithCommas } from "../../../common/functions/helperFunctions";
import TermAndCondition from "../../components/common/TermAndCondition";
import CPtoClipBoardModal from "../../components/modals/CPtoClipboard";
import OrderButton from "../../components/orderButton/OrderButton";
import CreateProjectInfoModel from "../myprojects/myProjectsModels/CreateProjectInfoModel";
import WPCalculator from "../../WPCalc/WPCalculator";

const MySwal = withReactContent(Swal);

// ** Styles
// import "@styles/base/pages/page-pricing.scss";

const SubscriptionManagement = ({ title }) => {
  const navigate = useNavigate();
  // ** local state
  const [isLoading, setIsloading] = useState(false);
  const [pricingCalculator, setPricingCalculator] = useState(false);
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [openTermModel, setOpenTermModel] = useState(false);

  const [projectInfoModel, setProjectInfoModel] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const [CopyModal, setCopyModal] = useState({ isOpen: false, data: "" });

  const [confSubscription, setConfSubscription] = useState({
    open: false,
    value: "",
  });

  // ** dispatch
  const dispatch = useDispatch();
  // ** get data from store
  const subscriptionData = useSelector((state) => state.subscription);
  const currentUser = useSelector((state) => state.currentUser);

  const openEditModal = (val) => {
    setConfSubscription({ open: true, value: val });
  };

  const handleConfSubscription = () => {
    setConfSubscription({
      open: false,
      value: "",
    });
    setIsCheck(false);
  };
  const handlePlan = async () => {
    const value = {
      subscription_id: confSubscription?.value?.id,
    };
    try {
      setIsloading(true);
      const res = await createStripeCustomer(
        value,
        currentUser?.currentuserdata?.data?.user_subscription_id
      );

      if (res?.data?.payment_method === "no_payment_method") {
        const payload = {
          planId: confSubscription?.value?.id,
          client_secret: res?.data?.client_secret,
        };
        dispatch(subscriptionDetails(payload));
        setPaymentPopup(true);
        setIsCheck(false);
      } else {
        setConfSubscription({ open: false, value: "" });
        MySwal.fire({
          title: "Subscription Purchased Successfully ",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        dispatch(getCurrentUser());
        navigate(USER_ROUTES.MY_PROJECTS);
        setIsCheck(false);
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
          />
        ));
      }
    } catch (err) {
      setConfSubscription({ open: false, value: "" });
      if (err.response?.data?.data?.redirect_to) {
        const win = window.open(
          err.response?.data?.data?.redirect_to,
          "_blank"
        );
        if (win === null || typeof win === "undefined") {
          setCopyModal({ isOpen: true, data: err.response?.data?.data });
          // Popup blocked, display message in UI
          toast((t) => (
            <ToastContent
              t={t.id}
              message="Popup blocked. Please enable popups and try again."
              color="danger"
              icon={<X size={12} />}
            />
          ));
        }
      } else {
        getErrorMsg(err);
      }
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (subscriptionData?.plans.data.length === 0) dispatch(fetchPlans());
  }, []);

  return (
    <>
      <div className="plans-offer">
        {!title ? (
          <>
            <div className="row justify-content-between align-items-center mb-2">
              <div className="d-flex back-div col-lg-9 col-12"></div>
              <div className="col-12 col-md-4 col-lg-3 text-start text-lg-end">
                <OrderButton
                  setProjectInfoModel={setProjectInfoModel}
                  projectInfoModel={projectInfoModel}
                />
              </div>
            </div>
            <h1 className="text-center my-2 section-title">Plans we offer</h1>
            <p className="text-center mb-3">
              Each plan includes quick 15 days turnaround.
            </p>
          </>
        ) : (
          ""
        )}

        <Row className="pricing-card">
          <Col xs={12} md={12} lg={12} xl={11} xxl={9} className="m-auto">
            <Row>
              {subscriptionData?.plans?.isFetching && <PlansSkeleton />}
              {subscriptionData?.plans?.data?.map((row) => (
                <Col xs={12} md={6} lg={6} xl={4} key={row.id}>
                  <Card
                    className={classnames("bordered shadow-none", {
                      ["active-plan"]:
                        row?.id ===
                        currentUser?.currentuserdata?.data?.subscription_id,
                      ["upcoming-plan"]:
                        row?.id ===
                        currentUser?.currentuserdata?.data
                          ?.upcoming_subscription_id,
                    })}
                  >
                    <CardBody>
                      <div className="d-flex align-items-center ">
                        <h2>{row.subscription_name}</h2>
                        {row?.id ===
                          currentUser?.currentuserdata?.data
                            ?.subscription_id && (
                          <Badge color="light-success" className="ms-75 h-100">
                            Active
                          </Badge>
                        )}
                        {currentUser?.currentuserdata?.data
                          ?.upcoming_subscription_id
                          ? row?.id ===
                              currentUser?.currentuserdata?.data
                                ?.upcoming_subscription_id && (
                              <Badge
                                color="light-warning"
                                className="ms-75 h-100"
                              >
                                Upcoming
                              </Badge>
                            )
                          : ""}
                      </div>
                      <div className="annual-plan">
                        <div className="price-div">
                          <span className="price">
                            ${numberWithCommas(row.pricing_per_month)}
                          </span>
                          <span className="pricing-duration text-body font-medium-1  ms-25">
                            /mo
                          </span>
                        </div>
                      </div>
                    </CardBody>
                    <div className="middle-points">
                      <CardBody className="">
                        <div>
                          <h4>
                            {numberWithCommas(row.caret)} Carats{" "}
                            <HelpCircle
                              className="mx-25 cursor-pointer"
                              id={`UnControlledExample${row.id}`}
                            />
                            <UncontrolledTooltip
                              placement="top"
                              target={`UnControlledExample${row.id}`}
                            >
                              Carats = points, basically! These are added to
                              your account when you subscribe to any of our
                              membership plans. You can use these Carats to pay
                              for video edits throughout the year. The higher
                              the plan, the more valuable your carats are,
                              indicated by the discount amounts listed on each
                              package. Still, finding it tricky? Don't worry We
                              provide a calculator to help you compare the cost
                              if you were to pay per edit versus using a
                              membership plan!
                            </UncontrolledTooltip>
                          </h4>
                        </div>
                        <p>{row.description}</p>
                      </CardBody>
                    </div>
                    <CardBody>
                      <ul>
                        <li>
                          <CheckCircle />
                          {row.short_desc}
                        </li>
                      </ul>

                      <Button
                        disabled={
                          row?.id ===
                            currentUser?.currentuserdata?.data
                              ?.subscription_id ||
                          row?.id ===
                            currentUser?.currentuserdata?.data
                              ?.upcoming_subscription_id ||
                          isLoading
                        }
                        block
                        outline={
                          row?.id ===
                            currentUser?.currentuserdata?.data
                              ?.subscription_id ||
                          row?.id ===
                            currentUser?.currentuserdata?.data
                              ?.upcoming_subscription_id
                        }
                        // outline={item.title !== "Standard"}
                        color="primary"
                        // color={
                        //   row?.id ===
                        //     currentUser?.currentuserdata?.data
                        //       ?.subscription_id ||
                        //   row?.id ===
                        //     currentUser?.currentuserdata?.data
                        //       ?.upcoming_subscription_id
                        //     ? "warning"
                        //     : "primary"
                        // }
                        onClick={() => {
                          openEditModal(row);
                          setOpenTermModel(true);
                        }}
                        // onClick={() => handlePlan(row.id)}
                      >
                        {/* {currentUser?.currentuserdata?.data
                          ?.user_subscription_id === null || undefined
                          ? "Buy Subscription"
                          : row?.id ===
                            currentUser?.currentuserdata?.data?.subscription_id
                          ? "Current Subscription"
                          : "Change Subscription"} */}
                        {currentUser?.currentuserdata?.data
                          ?.user_subscription_id === null ||
                        currentUser?.currentuserdata?.data
                          ?.user_subscription_id === undefined
                          ? "Buy Subscription"
                          : row?.id ===
                            currentUser?.currentuserdata?.data?.subscription_id
                          ? "Current Subscription"
                          : row?.id ===
                            currentUser?.currentuserdata?.data
                              ?.upcoming_subscription_id
                          ? "Upcoming Subscription"
                          : "Change Subscription"}
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
      {!title ? (
        <>
          <hr />
          <div className="text-center d-flex flex-column flex-md-row justify-content-center">
            <Button.Ripple
              className="ornge-btn"
              color="flat-primary"
              onClick={(e) => {
                e.preventDefault();
                setModalOpen(true);
              }}
            >
              {/* Want a Package Suitable For Your Needs? */}
              Compare With Pay As You Go Pricing
            </Button.Ripple>
            <Button.Ripple
              className="ornge-btn ms-0 ms-md-1 mt-1 mt-md-0"
              color="flat-primary"
              onClick={(e) => {
                e.preventDefault();
                setPricingCalculator(true);
              }}
            >
              {/* Want a Package Suitable For Your Needs? */}
              Calculate the Right Package for You!
            </Button.Ripple>
          </div>
          <hr />
        </>
      ) : (
        ""
      )}
      <StripeElement>
        <PaymentWizard
          show={paymentPopup}
          setShow={setPaymentPopup}
          module="subscription"
          setConfSubscription={setConfSubscription}
          setIsloading={setIsloading}
        />

        <PricingCalculatorModel
          setShow={setPricingCalculator}
          show={pricingCalculator}
        />
      </StripeElement>

      {modalOpen && (
        <WPCalculator modalOpen={modalOpen} setModalOpen={setModalOpen} />
      )}

      <ConfirmModel
        disabled={isLoading}
        title="Are you sure you want to purchase this subscription?"
        info={
          currentUser?.currentuserdata?.data?.subscription_id
            ? "We would like to inform you that the plan you are currently purchasing will only become active once your current plan expires."
            : ""
        }
        open={isCheck && confSubscription.open}
        setOpen={handleConfSubscription}
        handleClick={handlePlan}
        primaryBtnTitle={isLoading ? "Loading..." : "Yes"}
        modalSize="modal-lg"
      />
      <TermAndCondition
        isCheck={isCheck}
        setIsCheck={setIsCheck}
        open={openTermModel}
        close={setOpenTermModel}
        subscription
      />
      <CPtoClipBoardModal setCopyModal={setCopyModal} CopyModal={CopyModal} />
      {projectInfoModel && (
        <CreateProjectInfoModel
          show={projectInfoModel}
          setShow={setProjectInfoModel}
        />
      )}
    </>
  );
};

export default SubscriptionManagement;
